import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Filter } from 'lucide-react';
import { SCREENER_SECTORS } from './screenerConstants';

const FilterField = ({ label, type, placeholder, value, name, onChange, testId }) => (
  <div>
    <label className="text-xs font-medium text-gray-600">{label}</label>
    <Input
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange({ name, value: e.target.value })}
      data-testid={testId}
    />
  </div>
);

const AdvancedFiltersCard = ({ filters, onChange, onApply, loading }) => {
  const set = ({ name, value }) => onChange({ ...filters, [name]: value });
  return (
    <Card className="mb-8" data-testid="screener-filters-card">
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2">
          <Filter size={20} />
          Advanced Filters
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid md:grid-cols-5 gap-4">
          <FilterField label="Min Price" type="number" placeholder="$0" value={filters.minPrice} name="minPrice" onChange={set} testId="filter-min-price" />
          <FilterField label="Max Price" type="number" placeholder="$1000" value={filters.maxPrice} name="maxPrice" onChange={set} testId="filter-max-price" />
          <FilterField label="Min Volume" type="number" placeholder="1,000,000" value={filters.minVolume} name="minVolume" onChange={set} testId="filter-min-volume" />
          <FilterField label="Max P/E" type="number" placeholder="50" value={filters.maxPe} name="maxPe" onChange={set} testId="filter-max-pe" />
          <div>
            <label className="text-xs font-medium text-gray-600">Sector</label>
            <select
              className="w-full border border-gray-200 rounded-md px-3 py-2 text-sm h-10"
              value={filters.sector}
              onChange={(e) => set({ name: 'sector', value: e.target.value })}
              data-testid="filter-sector"
            >
              {SCREENER_SECTORS.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.label}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="mt-4 flex justify-end">
          <Button
            className="bg-purple-600 hover:bg-purple-700"
            onClick={onApply}
            disabled={loading}
            data-testid="filter-apply-btn"
          >
            {loading ? 'Running…' : 'Apply Filters'}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default AdvancedFiltersCard;
